module.exports = __webpack_public_path__ + "img/midea_logo.990a8cd1.png";